import styled from "styled-components";
import { Container } from "react-grid-system";
import { theme } from "../theme";

export const StyledUserSearchOptions = styled(Container)`
	padding-left: 0 !important;
	padding-right: 0 !important;
	display: flex;
	align-items: center;
	justify-content: space-between;
	flex-wrap: wrap;
	row-gap: 1.5rem;
	column-gap: 2rem;

	& > *:first-child {
		width: 100%;
	}

	& > *:not(:first-child):not(button) {
		width: 100%;
		margin-bottom: 1rem;
	}

	& > div {
		margin-bottom: 1rem;
	}
`;

export const StyledUserSearchActions = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: flex-end;
	flex-direction: column;
	column-gap: 4.5rem;
	height: 100%;

	& .action-buttons {
		width: calc(100% - 6.2rem);

		display: flex;
		justify-content: flex-end;
		align-items: center;
		column-gap: 3rem;

		position: absolute;
		bottom: 2.6rem;
		right: 3.1rem;
	}

	& .items {
		width: 100%;
		margin-top: 2rem;

		display: flex;
		flex-direction: column;
		row-gap: 0.8rem;

		&--choosen {
			margin-top: 1.5rem;
			padding-top: 1.5rem;

			border-top: 1px solid ${theme.color.black};
		}
	}

	& .form {
		width: 100%;
		margin-top: 3rem;
		margin-bottom: 1rem;

		display: flex;
		align-items: center;
		justify-content: space-between;

		column-gap: 2rem;

		& > *:nth-child(-n + 3) {
			width: 100%;
			margin-bottom: 0;

			& input {
				margin-bottom: 0;
			}
		}
	}

	& .form-buttons {
		height: 3rem;
		margin-bottom: 1rem;

		display: flex;
		align-items: center;
		justify-content: flex-end;

		& > * {
			margin-left: 2rem;
			cursor: pointer;
		}
	}

	& .item {
		width: 100%;
		margin-bottom: 0;

		display: flex;
		align-items: center;
		justify-content: flex-start;

		column-gap: 0.75rem;

		cursor: pointer;

		font-size: 1.2rem;
		font-weight: 300;
		text-transform: capitalize;

		&::selection,
		&::-moz-selection {
			background-color: transparent;
		}
	}
`;
